<template>
  <div class="bg-white rounded box-shadow p-1">
    <b-modal id="household-modal" size="lg" title="Household Information" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <label for="full_name">Name <span class="c-required">*</span></label>
            <input type="text" v-model="household.full_name" v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }" id="full_name" name="full_name" class="form-control form-control-sm" placeholder="Enter full name"/>
            <div class="invalid-feedback">Please enter full name</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="family_relation_id">Relation <span class="c-required">*</span></label>
            <select v-model="household.family_relation_id" v-validate="'required'" id="family_relation_id" name="family_relation_id" class="form-control form-control-sm" @change="getGender(household.family_relation_id)">
              <option selected :value="''">Select Family Relation</option>
              <option v-for="(family_relation, index) in family_relations" v-bind:value="family_relation.id" :key="index">{{ family_relation.id }} : {{ family_relation.family_relation_desc }}</option>
            </select>
            <div class="invalid-feedback">
              Please select family relation
            </div>
          </div>
          <div v-if="household.family_relation_id == 1" class="col-md-6 col-sm-6 col-lg-6">
            <label for="gender_id">Gender <span class="c-required">*</span></label>
            <span v-if="household_gender.gender_id == 1">
              <input disabled type="text" value="Male" name="gender_id" id="gender_id" class="custom-select custom-select-sm">
            </span>
            <span v-if="household_gender.gender_id == 2">
              <input disabled type="text" value="Female" name="gender_id" id="gender_id" class="custom-select custom-select-sm">
            </span>
            <div class="invalid-feedback">
              Please select gender
            </div>
          </div>
          <div v-else class="col-md-6 col-sm-6 col-lg-6">
            <label for="gender_id">Gender <span class="c-required">*</span></label>
            <select disabled v-model="household.gender_id" v-validate="'required'" id="gender_id" name="gender_id" class="custom-select custom-select-sm">
              <option :value="''" selected>Select Gender</option>
              <option v-for="(gender, index) in genders" v-bind:value="gender.id" :key="index">{{ gender.id }} : {{ gender.gender_desc }}</option>
            </select>
            <div class="invalid-feedback">
              Please select gender
            </div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="age">Age</label>
            <input type="number" v-model="household.age" v-validate="'numeric'" id="age" name="age" class="form-control form-control-sm" placeholder="Enter age"/>
            <div class="invalid-feedback">Please enter age in number format</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="education_id">Education <span class="c-required">*</span></label>
            <select v-model="household.education_id" v-validate="'required'" id="education_id" name="education_id" class="form-control form-control-sm" @change="getGender(household.family_relation_id)">
              <option selected :value="''">Select Education</option>
              <option v-for="(education, index) in educations" v-bind:value="education.id" :key="index">{{ education.id }} : {{ education.education_desc }}</option>
            </select>
            <div class="invalid-feedback">
              Please select education
            </div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="marital_status_id">Marital Status <span class="c-required">*</span></label>
            <select v-model="household.marital_status_id" v-validate="'required'" id="marital_status_id" name="marital_status_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Marital Status</option>
              <option v-for="(marital_status, index) in marital_statuses" v-bind:value="marital_status.id" :key="index">{{ marital_status.id }} : {{ marital_status.marital_status_desc }}</option>
            </select>
            <div class="invalid-feedback">
              Please select marital status
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="occupation_id">Occupation <span class="c-required">*</span></label>
            <select v-model="household.occupation_id" v-validate="'required'" id="occupation_id" name="occupation_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Occupation</option>
              <option v-for="(occupation, index) in occupations" v-bind:value="occupation.id" :key="index">{{ occupation.id }} : {{ occupation.occupation_desc }}</option>
            </select>
            <div class="invalid-feedback">
              Please select occupation
            </div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="secondary_occupation_id">Secondary Occupation</label>
            <select v-model="household.secondary_occupation_id"  id="secondary_occupation_id" name="secondary_occupation_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Secondary Occupation</option>
              <option v-for="(occupation, index) in occupations" v-bind:value="occupation.id" :key="index">{{ occupation.id }} : {{ occupation.occupation_desc }}</option>
            </select>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="yearly_income">Yearly Income (BDT)</label>
            <input type="number" v-model="household.yearly_income" v-validate="'numeric|max:9'" id="yearly_income" name="yearly_income" class="form-control form-control-sm" placeholder="Enter yearly income"/>
            <div class="invalid-feedback">Please enter yearly income number format and Not greater then 9 digit</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="is_disable">Is disabled <span class="c-required">*</span></label>
            <select v-model="household.is_disable" id="is_disable" name="is_disable" class="form-control form-control-sm">
              <option value="0" selected="selected">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="remarks">Remarks</label>
            <input type="text" v-model="household.remarks" id="remarks" name="remarks" class="form-control form-control-sm"/>
          </div>
        </div>
        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Add Household</b-button>
            <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update Household</b-button>
            <b-button size="sm" variant="danger" class="form-control-sm" @click="$bvModal.hide('household-modal')">Cancel</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import http from "@state/http";

  export default {
    props: ["household","btn_edit"],

    components: { },
    data() {
      return {
        family_relations: [],
        genders: [],
        marital_statuses: [],
        occupations: [],
        educations: [],
        validation_errors: {},
        household_gender: {},
        show: false,
      };
    },
    mounted() {
      this.getCodes();
      this.householdGender();
    },
    methods: {
      save() {
        this.$validator.validate().then(valid => {
          if (valid) {
            http.post("api/households", this.household)
                    .then(response => {
                      if (!response.data.error) {
                        this.$bvModal.hide("household-modal");
                        this.$emit("resetForm");
                        this.$bvToast.toast(response.data.message, {
                          title: "Success",
                          autoHideDelay: 5000,
                          variant: "success"
                        });
                        this.$emit("getPersonHousehold");
                      }
                    })
                    .catch(error => {
                      this.validation_errors = error.response.data.errors;
                      this.show = true;
                      this.hide();
                    });
          }
        });
      },
      update() {
        this.$validator.validate().then(valid => {
          if (valid) {
            http.put("api/households/" + this.household.id, this.household)
                    .then(response => {
                      if (!response.data.error) {
                        this.$bvModal.hide("household-modal");
                        this.$bvToast.toast(response.data.message, {
                          title: "Success",
                          autoHideDelay: 5000,
                          variant: "success"
                        });
                         this.$emit("getPersonHousehold");
                      } else {
                        this.$bvToast.toast("Update Failed", {
                          title: "Error",
                          autoHideDelay: 5000,
                          variant: "danger"
                        });
                      }
                    })
                    .catch(error => {
                      this.validation_errors = error.response.data.errors;
                      this.show = true;
                      this.hide();
                      this.$bvToast.toast("Update Failed", {
                        title: "Error",
                        autoHideDelay: 5000,
                        variant: "danger"
                      });
                    });
          }
        });
      },
      getCodes() {
        http.get("api/household/codes").then(response => {
          if (!response.error) {
            let data = response.data;
            this.family_relations = data.family_relations;
            this.marital_statuses = data.marital_statuses;
            this.occupations = data.occupations;
            this.educations = data.educations;
            this.genders = data.genders;
          }
        });
      },
      householdGender(){
        let ses_id = this.$route.params.ses_id;
        http.get("api/household/gender/" + ses_id).then(response => {
          if (!response.error) {
            let data = response.data;
            this.household_gender = data.household_gender;
          }
        });
      },
      getGender(family_relation_id){
        let family_relation = this.family_relations.find(family_relation => family_relation.id == family_relation_id);

        let gender = this.genders.find(gender => gender.id == family_relation.gender_id);
        this.household.gender_id = gender.id;
      },
      hide() {
        setTimeout(() => {
          this.show = false;
        }, 5000);
      },
    },
  };
</script>
<style>
  .c-required{
    color: red;
  }
</style>
